import React from 'react';
import Help from '../components/sections/Help';
import VolunteerDocs from '../components/sections/VolunteerDocs';
import SEO from '../components/SEO';
import { SITE } from '../data/site';

const Ajudar: React.FC = () => (
  <>
    <SEO
      title="Como Ajudar | Patinhas Sem Lar"
      description="Saiba como apoiar a Patinhas Sem Lar através de donativos, bens, voluntariado ou acolhimento."
      path="/ajudar"
    />
    <Help donation={SITE.donation} />
    <VolunteerDocs />
  </>
);

export default Ajudar;
